import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <section class="ud-page-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="ud-banner-content">
                <h1>404</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ud-404">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="ud-404-wrapper">
                <div class="ud-404-content">
                  <h2 class="ud-404-title">Aradığınız sayfa bulunamadı.</h2>
                  <h5 class="ud-404-subtitle">
                    Belki aşağıdaki sayfalardan ihtiyacınızı bulabilirsiniz:
                  </h5>
                  <ul class="ud-404-links">
                    <li>
                      <a href="/">Anasayfa</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
